import { render } from "./Vraag.vue?vue&type=template&id=fe4190cc&scoped=true"
import script from "./Vraag.vue?vue&type=script&lang=js"
export * from "./Vraag.vue?vue&type=script&lang=js"

import "./Vraag.vue?vue&type=style&index=0&id=fe4190cc&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4190cc"]])

export default __exports__